import { FormGroupInput, Card, DropDown, Button } from '../components/index';
import VueSlider from 'vue-slider-component';
import Multiselect from 'vue-multiselect';
import 'vue-slider-component/theme/antd.css';
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component('vue-slider', VueSlider);
    Vue.component('multiselect', Multiselect);
    Vue.component('fg-input', FormGroupInput);
    Vue.component('drop-down', DropDown);
    Vue.component('card', Card);
    Vue.component('p-button', Button);
  },
};

export default GlobalComponents;
